import React from "react";
import { ScrollMenu, VisibilityContext } from "react-horizontal-scrolling-menu";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ContentCard from "./contentCard";
import { Link } from "gatsby";

const SuggestBlock = ({
  block,
  hideOverlayAndImage,
  idCategory,
  categoryPath = "Recomendados",
  userHasSuscription,
  useDetailedLink = false,
  hideViewAll = false, // nueva prop, por defecto false
}) => {
  console.log(block);

  const LeftArrow = () => {
    const { scrollPrev } = React.useContext(VisibilityContext);
    return (
      <div onClick={() => scrollPrev()} style={{ cursor: "pointer" }}>
        <ArrowBackIosIcon />
      </div>
    );
  };

  const RightArrow = () => {
    const { scrollNext } = React.useContext(VisibilityContext);
    return (
      <div onClick={() => scrollNext()} style={{ cursor: "pointer" }}>
        <ArrowForwardIosIcon />
      </div>
    );
  };

  return (
    <div className="mb-8">
      <div className="flex w-full justify-between items-center mb-4">
        <h3 className="text-sc-titles">{block.titulo}</h3>
        { !hideViewAll && (
          <Link
            to={
              useDetailedLink
                ? `/sections/${idCategory}/${block.id}`
                : `/${categoryPath}`
            }
          >
            Ver todo
          </Link>
        ) }
      </div>

      {/* Vista para pantallas grandes */}
      <div className="hidden md:block">
        <ScrollMenu LeftArrow={LeftArrow} RightArrow={RightArrow}>
          {block.cards.map((card) => (
            <ContentCard
              key={card.id}
              card={card}
              itemId={card.id}
              userHasSuscription={userHasSuscription ?? null}
            />
          ))}
        </ScrollMenu>
      </div>

      {/* Vista para móviles */}
      <div className="block md:hidden flex overflow-x-scroll w-full scroll-hidden">
        {block.cards.map((card) => (
          <ContentCard
            key={card.id}
            card={card}
            userHasSuscription={userHasSuscription ?? null}
          />
        ))}
      </div>
    </div>
  );
};

export default SuggestBlock;
